import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import Typography from 'kingpin/atoms/Typography';
import useKbDomains from 'hooks/useKbDomains';

import { AgentKbContext } from './AgentKbProvider';
import ArtefactEditor from './ArtefactEditor';
import { artefactForDomain } from './nav/artefactForDomain';
import { domainDisplayName } from './ContentTab/constants';

// A domain's knowledge: the domain-skill artefact's editor, or a "not shipped"
// state when the account flags content for a domain the resolved KB has no
// skill for (the agent can't load it, so the fix is a KB publish, not an edit
// here).

const PageDiv = styled.div`
  flex: 1;
  overflow-y: auto;
`;

const CenteredDiv = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px;
`;

const DomainKnowledgePanel = () => {
  const { domainId } = useParams<{ domainId: string }>();
  const { artefacts } = useContext(AgentKbContext);
  const { domainGroups } = useKbDomains();

  const domain = decodeURIComponent(domainId ?? '');
  const artefact = artefactForDomain({ domain, artefacts });

  if (!artefact) {
    // Empty groups means the KB was unreadable — say so rather than "not
    // shipped", which would be a false accusation.
    const unreadable = domainGroups.length === 0;
    return (
      <CenteredDiv>
        <Typography.Body type="Body 13" color="var(--color-text-secondary)">
          {unreadable
            ? `The knowledge base could not be read, so ${domainDisplayName(
                domain,
              )} has no editable skill here.`
            : `${domainDisplayName(
                domain,
              )} is used on this account but the resolved knowledge base ships no skill for it. Publish a KB version that includes it.`}
        </Typography.Body>
      </CenteredDiv>
    );
  }

  return (
    <PageDiv>
      <ArtefactEditor artefact={artefact} />
    </PageDiv>
  );
};

export default DomainKnowledgePanel;
